import React, { useState, useCallback, useEffect, useMemo } from "react";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
import { locationSample } from "../../../../utils/schema/locationSample";
import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import { useNavigate } from "react-router-dom";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import CreateLocation from "./DIalogBoxes/CreateLocation";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { getApi, putApi, deleteApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import EditLocation from "./DIalogBoxes/EditLocation";
import { message, Pagination } from "antd";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../Auth/PopupCard";
import { useSelector } from "react-redux";
import PermissionForm from "../../../Auth/PermissionForm";
const MobileCard = ({ item }) => (
  <div
    key={item.key}
    className="bg-white rounded-xl shadow-md border border-gray-200 p-4 mb-4"
    style={{
      background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
    }}
  >
    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">#</span>
      <span className="text-gray-800">{item.serial}</span>
    </div>

    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">Location</span>
      <span className="text-gray-800 text-right max-w-[60%]">
        {item.location}
      </span>
    </div>

    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">Description</span>
      <span className="text-gray-800 text-right max-w-[60%]">
        {item.description || "-"}
      </span>
    </div>

    <div className="flex justify-between items-center mt-2">
      <span className="font-semibold text-gray-600">Action</span>
      <div className="flex gap-3">{item.action}</div>
    </div>
  </div>
);

const LocationUser = () => {
  const navigate = useNavigate();
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [showStatusDialog, setShowStatusDialog] = useState(false);

  const initialStatusData = locationSample.map((item) => ({
    ...item,
    status: true,
  }));

  const [locations, setLocations] = useState(initialStatusData);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedlocation, setSelectedLocation] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Location Name", key: "location" },
    { label: "Description", key: "description" },
    { label: "Action", key: "action" },
  ];

  const fetchLocations = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.ALL_LOCATIONUSERS(page, pageSize, searchTerm),
        });

        if (response.data.data) {
          const locationData = response.data.data.map((item, index) => ({
            key: item._id,
            serial: (
              <div className="text-center" title="">
                {(page - 1) * pageSize + (index + 1)}
              </div>
            ),
            location: (
              <div className="text-center" title="">
                {item.location_name}
              </div>
            ),
            description: (
              <div className="text-center" title="">
                {item.description}
              </div>
            ),
            action: (
              <div className="flex justify-center items-center gap-3" title="">
                <EditIcon
                  style={{ marginRight: 10, cursor: "pointer" }}
                  onClick={() => {
                    setSelectedLocation(item);
                    setOpenEditDialog(true);
                  }}
                />
                <DeleteIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDeleteLocation(item._id)}
                />
                <CustomSwitch
                  checked={item.status === "Active"}
                  onChange={() => handleToggleStatus(item._id, item.status)}
                />
              </div>
            ),
          }));

          setLocations(locationData);
          setTotal(response.data.metadata?.total || locationData.length);
        } else {
          setLocations([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        setLocations([]);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm],
  );

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  useEffect(() => {
    fetchLocations(pageNo);
  }, [fetchLocations, pageNo]);

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

  const handleDeleteLocation = async (id) => {
    try {
      setLoading(true);
      const res = await deleteApi({ apiUrl: API_URLS.DELETE_LOCATION(id) });

      if (res?.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Location delete successfully.
        //       </h2>
        //     </div>
        //   ),
        // });

        triggerPopup("success", "Success", " Location delete successfully!");

        setTimeout(() => {
          fetchLocations(pageNo); // ✅ refresh after delete
        }, 2000);
      } else {
        // message.error({
        //   content: res?.message || "Failed to delete Location.",
        //   duration: 2,
        // });

        triggerPopup(
          "error",
          "Add User Failed",
          res?.message || "Failed to delete Location.",
        );
      }
    } catch (error) {
      // console.error("Delete error:", error);
      // message.error({
      //   content: "An unexpected error occurred while deleting the role.",
      //   duration: 2,
      // });

      triggerPopup(
        "error",
        "Add User Failed",
        "An unexpected error occurred while deleting the role",
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleToggleStatus = async (locationId, currentStatus) => {
  //   try {
  //     const newStatus = currentStatus === "Active" ? "Deactive" : "Active";
  //     await putApi({
  //       apiUrl: API_URLS.EDIT_LOCATIONUSER(locationId),
  //       data: { status: newStatus },
  //     });
  //     setStatusMessage(
  //       `Location user ${newStatus === "Active" ? "Active" : "Inactive"} is successfully.`,
  //     );
  //     setIsSuccess(newStatus === "Active");
  //     setShowStatusDialog(true);
  //     fetchLocations(pageNo);
  //   } catch (error) {
  //     console.error("Error updating user status:", error);
  //   }
  // };

  // Add this handler function for the button click

  const handleToggleStatus = async (locationId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Deactive" : "Active";

      const response = await putApi({
        apiUrl: API_URLS.EDIT_LOCATIONUSER(locationId),
        data: { status: newStatus },
      });

      if (response?.success) {
        triggerPopup(
          "success",
          "Status Updated",
          `Location user status changed to ${newStatus} successfully`,
        );
        fetchLocations(pageNo);
      } else {
        triggerPopup(
          "error",
          "Update Failed",
          response?.message || "Failed to update location user status",
        );
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      triggerPopup(
        "error",
        "Update Failed",
        "Something went wrong while updating location user status",
      );
    }
  };

  const handleAddNewClick = () => {
    console.log("Add New button clicked"); // Debug log
    setOpenCreateDialog(true);
  };

  const sortedData = useMemo(() => {
    let data = [...locations];
    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }
    return data;
  }, [locations, sortBy, sortOrder]);

  // Debug log to check state
  console.log("openCreateDialog state:", openCreateDialog);
  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);
  return (
    <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      <div className="">
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <p>User Management</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}> Location User</TextStyles>
        </div>

        <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          {/* <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
          /> */}
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Location User
          </div>
        </div>

        <div className="border border-[#ebedf3] rounded-xl pt-5 bg-[#fff] ">
          <div className="flex flex-wrap justify-between items-center px-4 mb-4 gap-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto">
              <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
                TOTAL LOCATION {locations.length}
              </div>
              <SearchBar width="100%" onSearch={setSearchTerm} />
            </div>
            {/* Fixed CustomButton with explicit handler */}
            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Add New"
              onClick={handleAddNewClick}
              className="text-sm sm:text-base font-normal h-[45px] sm:h-[50px] w-full sm:w-[160px]"
            />
          </div>

          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <Tables
              data={sortedData}
              headers={headers}
              pageSize={pageSize}
              current={pageNo}
              total={total}
              loading={loading}
              onChange={(page) => setPageNo(page)}
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden px-4 pb-4">
            {loading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Loading...</div>
              </div>
            ) : sortedData.length === 0 ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">No locations found</div>
              </div>
            ) : (
              <>
                {sortedData.map((item) => (
                  <MobileCard key={item.key} item={item} />
                ))}

                {/* Mobile Pagination */}
                <div className="flex justify-center mt-4">
                  <Pagination
                    current={pageNo}
                    total={total}
                    pageSize={pageSize}
                    onChange={(page) => setPageNo(page)}
                    showSizeChanger={false}
                    size="small"
                    showQuickJumper={false}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* CreateLocation Dialog - Make sure it renders */}
        {openCreateDialog && (
          <CreateLocation
            onOpen={openCreateDialog}
            onClose={() => {
              console.log("Closing CreateLocation dialog"); // Debug log
              setOpenCreateDialog(false);
            }}
            onSuccess={() => {
              console.log("CreateLocation success"); // Debug log

              setOpenCreateDialog(false);
              fetchLocations(pageNo);
            }}
          />
        )}

        {/* EditLocation Dialog */}
        {openEditDialog && selectedlocation && (
          <EditLocation
            onOpen={openEditDialog}
            onClose={() => setOpenEditDialog(false)}
            locationData={selectedlocation}
            //onUpdate={fetchLocations}
            onUpdate={() => {
              // ✅ refresh after edit
              setOpenEditDialog(false);
              fetchLocations(pageNo);
            }}
          />
        )}
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationUser;
